import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useGooglePayChargeTransaction from '@/hooks/useApi/useGooglePayChargeTransaction';
import usePayPal from '@/hooks/useApi/usePayPal';
import useVenmo from '@/hooks/useApi/useVenmo';
import DigitalWalletTransactionInfo from './DigitalWalletTransactionInfo';
import { useDataFetchIndicator } from '@/hooks';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type FC = FunctionComponent<vp.TransactionId & { transactionType: 'GooglePay' | 'PayPal' | 'Venmo' }>;

type DigitalWalletTransaction =
  | vp.GooglePayChargeTransactionResponse
  | vp.PayPalWithdrawTransactionResponse
  | vp.VenmoWithdrawTransactionResponse;

const DigitalWalletTransactionContainer: FC = (props) => {
  const { TransactionID, transactionType } = props;
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<DigitalWalletTransaction>();
  const [, setLoading] = useDataFetchIndicator();
  const alertDialog = useAlertDialog();

  // Hook usage based on transaction type
  const { fetchGooglePayChargeTransaction } = useGooglePayChargeTransaction();
  const { fetchPayPalWithdrawTransaction } = usePayPal();
  const { fetchVenmoWithdrawTransaction } = useVenmo();

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        setLoading(true);
        if (transactionType === 'GooglePay') {
          const resp = await fetchGooglePayChargeTransaction(TransactionID);
          setTransaction(resp);
        } else if (transactionType === 'PayPal') {
          const resp = await fetchPayPalWithdrawTransaction(TransactionID);
          setTransaction(resp);
        } else if (transactionType === 'Venmo') {
          const resp = await fetchVenmoWithdrawTransaction(TransactionID);
          setTransaction(resp);
        }
      } catch (error) {
        alertDialog.error('Error', error instanceof Error ? error.message : 'An unexpected error occurred.');
      } finally {
        setLoading(false);
      }
    };
    fetchTransaction();
  }, [currentTransactionId, transactionType]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && <DigitalWalletTransactionInfo transaction={transaction} transactionType={transactionType} />}
    </div>
  );
};

export default DigitalWalletTransactionContainer;
